// extracted by mini-css-extract-plugin
module.exports = {"error":"All_error__1vJJq","no-data":"All_no-data__3Nysm"};